/**
 * 项目基本信息
 */
import { any } from 'prop-types';
import '../../MajorProjectTimeline.less';
import { Collapse, Table, Tooltip } from 'antd';
import { isEmpty } from 'lodash';
import { QuestionCircleOutlined } from '@ant-design/icons';
import DictionaryMatching from '@/components/DictionaryMatching/DictionaryMatching';
import FileDownload from '@/components/FileDownload/FileDownload';
import EquipmentExpandTable from '@/pages/agriculturalSubsidies/Application/components/EquipmentExpandTable';

const { Panel } = Collapse;
function ProjectBasicInfo({ data, dict }) {
  const columns = [
    {
      title: '序号',
      dataIndex: 'rowKey',
      width: 60,
    },
    {
      title: '子项名称',
      dataIndex: 'projectName',
      render: (text) => <DictionaryMatching value={text} dictionary={dict?.specialProjectName} />,
    },
    {
      title: '建设内容',
      dataIndex: 'constructionContent',
    },
    {
      title: '投资总额(万元)',
      children: [
        {
          title: '合计',
          dataIndex: 'totalAmount',
          width: 100,
        },
        {
          title: '省级专项资金',
          dataIndex: 'provincialSubsidyFunds',
          width: 80,
        },
        {
          title: '市县资金',
          dataIndex: 'cityFunding',
          width: 80,
        },
        {
          title: '企业自筹资金',
          dataIndex: 'selfFunding',
          width: 80,
        },
        {
          title: '其他资金',
          dataIndex: 'otherFunding',
          width: 80,
        },
      ],
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 150,
      ellipsis: true,
    },
  ];

  return (
    <div>
      <div className="myapplication-detail__sub-tiny-title">项目信息</div>
      <Collapse defaultActiveKey={['1', '2', '3', '4', '5', '6', '7', '8', '9']}>
        <Panel key="1" header="项目概况">
          <div className="myapplication-detail__grid">
            <div>
              项目名称：
              {data?.projectName}
            </div>
            <div>
              建设单位：
              {data?.projectUnit}
            </div>
            <div>
              申报年度：
              {data?.declarationYear}
            </div>
            <div>
              建设性质：
              {data?.projectNature?.split(',').map((item, index) => (
                <>
                  <DictionaryMatching key={item} value={item} dictionary={dict?.specialAgriculturalType} />
                  {index < data.projectNature.split(',').length - 1 ? '、' : ''}
                </>
              ))}
            </div>
            <div>
              项目建设区域：
              {data?.projectProvinceIdCode}
              -
              {data?.projectCityIdCode}
              -
              {data?.projectAreaIdCode}
            </div>
            <div>
              建设期限：
              {data?.projectConstructionPeriodStart}
              {data?.projectConstructionPeriodEnd && '-'}
              {data?.projectConstructionPeriodEnd}
            </div>
            <div>
              项目建设地址：
              {data?.projectConstructionAddress}
            </div>
          </div>
        </Panel>
        {/* <Panel key="2" header="项目背景与必要项"> */}
        {/*  <div> */}
        {/*    <div className="myapplication-detail__grid24"> */}
        {/*      <div>行业背景：</div> */}
        {/*      <div>{data?.industryBackground}</div> */}
        {/*    </div> */}
        {/*    <div className="myapplication-detail__grid24"> */}
        {/*      <div>项目背景：</div> */}
        {/*      <div>{data?.projectBackground}</div> */}
        {/*    </div> */}
        {/*    <div className="myapplication-detail__grid24"> */}
        {/*      <div>项目必要项：</div> */}
        {/*      <div>{data?.projectEssential}</div> */}
        {/*    </div> */}
        {/*  </div> */}
        {/* </Panel> */}
        <Panel key="3" header="项目建设方案">
          <div>
            <div className="myapplication-detail__grid24">
              <div>产品方案：</div>
              <div>{data?.projectScheme}</div>
            </div>
            <div className="myapplication-detail__grid24">
              <div>技术方案：</div>
              <div>{data?.technicalProposal}</div>
            </div>
            <div className="myapplication-detail__grid24">
              <div>建设内容：</div>
              <div>{data?.constructionContent}</div>
            </div>
          </div>
        </Panel>
        <Panel key="4" header="投资估算与资金筹措">
          <div className="myapplication-detail__grid">
            <div>
              总投资金额（万元）：
              {data?.totalAmount}
            </div>
            <div>
              省级专项资金（万元）：
              {data?.provincialSubsidyFunds}
            </div>
            <div>
              市县资金（万元）：
              {data?.cityFunding}
            </div>
            <div>
              企业自筹资金（万元）：
              {data?.selfFunding}
            </div>
            <div>
              其他资金（万元）：
              {data?.otherFunding}
            </div>
          </div>
          <div>
            <div style={{ color: '#333333', margin: '12px 0' }}>项目建设资金使用方案表：</div>
            <div>
              {
                !isEmpty(data?.specialAgriculturalFoundsVos)
                && (
                  <Table
                    rowKey="rowKey"
                    columns={columns}
                    dataSource={data?.specialAgriculturalFoundsVos}
                    pagination={false}
                    size="small"
                    expandable={{
                      // eslint-disable-next-line react/no-unstable-nested-components
                      expandedRowRender: (record) => (
                        <EquipmentExpandTable data={record.specialAgriculturalFundsEquips || []} />
                      ),
                      rowExpandable: (record) => !isEmpty(record.specialAgriculturalFundsEquips),
                    }}
                  />
                )
              }
            </div>
          </div>
        </Panel>
        <Panel key="5" header="施工进度与组织管理">
          <div>
            <div className="myapplication-detail__grid24">
              <div>建设进度：</div>
              <div>{data?.constructionProgress}</div>
            </div>
            <div className="myapplication-detail__grid24">
              <div>施工组织：</div>
              <div>{data?.constructionOrganization}</div>
            </div>
          </div>
        </Panel>
        <Panel key="6" header="效益分析">
          <div>
            <div className="myapplication-detail__grid24">
              <div>经济效益分析：</div>
              <div>{data?.benefitAnalysis}</div>
            </div>
            <div className="myapplication-detail__grid24">
              <div>社会效益分析：</div>
              <div>{data?.socialAnalysis}</div>
            </div>
          </div>
        </Panel>
        <Panel key="7" header="风险评估与应对措施">
          <div>
            <div className="myapplication-detail__grid24">
              <div>市场风险：</div>
              <div>{data?.marketRisk}</div>
            </div>
            <div className="myapplication-detail__grid24">
              <div>技术风险：</div>
              <div>{data?.technicalRisk}</div>
            </div>
            <div className="myapplication-detail__grid24">
              <div>政策风险：</div>
              <div>{data?.policyRisk}</div>
            </div>
          </div>
        </Panel>
        <Panel key="9" header="项目申报书">
          <div>
            <div className="myapplication-detail__grid24">
              <div style={{ lineHeight: '32px' }}>项目申报书：</div>
              <div style={{ margin: 0 }}>
                {data?.projectApplication?.map((item) => (
                  <FileDownload
                    key={item.id}
                    appendixName={item.fileName}
                    attachmentId={Number(item.id)}
                    url="/special/agricultural/download"
                  />
                ))}
              </div>
            </div>
          </div>
        </Panel>
        <Panel key="8" header="附件材料">
          <div>
            <div className="myapplication-detail__grid24">
              <div style={{ lineHeight: '32px', width: 300, textAlign: 'right' }}>
                建设单位承诺函：
                <Tooltip title="包括但不限对申报资料真实性、项目建设自筹资金到位、工程建设进度控制等承诺。需单位法人代表签字和单位盖章">
                  <QuestionCircleOutlined />
                </Tooltip>
              </div>
              <div style={{ margin: 0 }}>
                {data?.constructionUnit?.map((item) => (
                  <FileDownload
                    key={item.id}
                    appendixName={item.fileName}
                    attachmentId={Number(item.id)}
                    url="/special/agricultural/download"
                  />
                ))}
              </div>
            </div>
            <div className="myapplication-detail__grid24">
              <div style={{ lineHeight: '32px', width: 300, textAlign: 'right' }}>
              项目可研报告：
                <br />
                （项目立项前期可行性研究报告等资料）
              </div>
              <div style={{ margin: 0 }}>
                {data?.studyReport?.map((item) => (
                  <FileDownload
                    key={item.id}
                    appendixName={item.fileName}
                    attachmentId={Number(item.id)}
                    url="/special/agricultural/download"
                  />
                ))}
              </div>
            </div>
            <div className="myapplication-detail__grid24">
              <div style={{ lineHeight: '32px', width: 300, textAlign: 'right' }}>项目前期审批资料：</div>
              <div style={{ margin: 0 }}>
                {data?.leaseAgreement?.map((item) => (
                  <FileDownload
                    key={item.id}
                    appendixName={item.fileName}
                    attachmentId={Number(item.id)}
                    url="/special/agricultural/download"
                  />
                ))}
              </div>
            </div>
            <div className="myapplication-detail__grid24">
              <div style={{ lineHeight: '32px', width: 300, textAlign: 'right' }}>
                建设单位财务报表：
                <br />
                （项目建设承担单位近两年的财务报表）
              </div>
              <div style={{ margin: 0 }}>
                {data?.approvalDocuments?.map((item) => (
                  <FileDownload
                    key={item.id}
                    appendixName={item.fileName}
                    attachmentId={Number(item.id)}
                    url="/special/agricultural/download"
                  />
                ))}
              </div>
            </div>
            <div className="myapplication-detail__grid24">
              <div style={{ lineHeight: '32px', width: 300, textAlign: 'right' }}>
                主导产业发展支持政策文件：
                <br />
                （仅附关键页）
              </div>
              <div style={{ margin: 0 }}>
                {data?.policyDocument?.map((item) => (
                  <FileDownload
                    key={item.id}
                    appendixName={item.fileName}
                    attachmentId={Number(item.id)}
                    url="/special/agricultural/download"
                  />
                ))}
              </div>
            </div>
            <div className="myapplication-detail__grid24">
              <div style={{ lineHeight: '32px', width: 300, textAlign: 'right' }}>营业执照：</div>
              <div style={{ margin: 0 }}>
                {data?.businessLicense?.map((item) => (
                  <FileDownload
                    key={item.id}
                    appendixName={item.fileName}
                    attachmentId={Number(item.id)}
                    url="/special/agricultural/download"
                  />
                ))}
              </div>
            </div>
            {
              data?.enterType === '1' && (
                <>
                  <div className="myapplication-detail__grid24">
                    <div style={{ lineHeight: '32px', width: 300, textAlign: 'right' }}>龙头企业证明材料：</div>
                    <div style={{ margin: 0 }}>
                      {data?.leadingEnterprises?.map((item) => (
                        <FileDownload
                          key={item.id}
                          appendixName={item.fileName}
                          attachmentId={Number(item.id)}
                          url="/special/agricultural/download"
                        />
                      ))}
                    </div>
                  </div>
                  <div className="myapplication-detail__grid24">
                    <div style={{ lineHeight: '32px', width: 300, textAlign: 'right' }}>主营业务农业产值证明材料：</div>
                    <div style={{ margin: 0 }}>
                      {data?.mainBusiness?.map((item) => (
                        <FileDownload
                          key={item.id}
                          appendixName={item.fileName}
                          attachmentId={Number(item.id)}
                          url="/special/agricultural/download"
                        />
                      ))}
                    </div>
                  </div>
                  <div className="myapplication-detail__grid24">
                    <div style={{ lineHeight: '32px', width: 300, textAlign: 'right' }}>
                      上年度相关证明材料：
                      <br />
                      （销售收入、固定资产、总资产等）
                    </div>
                    <div style={{ margin: 0 }}>
                      {data?.previousYear?.map((item) => (
                        <FileDownload
                          key={item.id}
                          appendixName={item.fileName}
                          attachmentId={Number(item.id)}
                          url="/special/agricultural/download"
                        />
                      ))}
                    </div>
                  </div>
                </>
              )
            }
            {
              data?.enterType === '2' && (
                <>
                  <div className="myapplication-detail__grid24">
                    <div style={{ lineHeight: '32px', width: 300, textAlign: 'right' }}>加工设施设备资金情况证明材料：</div>
                    <div style={{ margin: 0 }}>
                      {data?.processingFacilities?.map((item) => (
                        <FileDownload
                          key={item.id}
                          appendixName={item.fileName}
                          attachmentId={Number(item.id)}
                          url="/special/agricultural/download"
                        />
                      ))}
                    </div>
                  </div>
                  <div className="myapplication-detail__grid24">
                    <div style={{ lineHeight: '32px', width: 300, textAlign: 'right' }}>联农带农机制证明材料：</div>
                    <div style={{ margin: 0 }}>
                      {data?.linkingFarmers?.map((item) => (
                        <FileDownload
                          key={item.id}
                          appendixName={item.fileName}
                          attachmentId={Number(item.id)}
                          url="/special/agricultural/download"
                        />
                      ))}
                    </div>
                  </div>
                </>
              )
            }
            <div className="myapplication-detail__grid24">
              <div style={{ lineHeight: '32px', width: 300, textAlign: 'right' }}>其他必要的相关材料：</div>
              <div style={{ margin: 0 }}>
                {data?.otherDocument?.map((item) => (
                  <FileDownload
                    key={item.id}
                    appendixName={item.fileName}
                    attachmentId={Number(item.id)}
                    url="/special/agricultural/download"
                  />
                ))}
              </div>
            </div>
          </div>
        </Panel>
      </Collapse>
    </div>
  );
}

export default ProjectBasicInfo;

ProjectBasicInfo.propTypes = {
  data: any,
  dict: any,
};
